'use client';

import { useEffect } from 'react';
import { reportError, isChunkLoadError, reloadIfStaleBuild } from '../lib/error-logger';
import ErrorPageTracker from './ErrorPageTracker';

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    console.error('Global error:', error);

    if (isChunkLoadError(error?.message)) {
      window.location.reload();
      return;
    }

    reloadIfStaleBuild(error?.stack).then((reloaded) => {
      if (!reloaded) reportError(error);
    });
  }, [error]);

  return (
    <html lang="es">
      <body>
        {!isChunkLoadError(error?.message) && <ErrorPageTracker error={error} boundary="global" />}
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '1rem', fontFamily: 'system-ui, sans-serif' }}>
          <div style={{ maxWidth: '28rem', width: '100%', padding: '2.5rem', borderRadius: '0.75rem', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', textAlign: 'center', background: 'white' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1a1a1a' }}>Algo salió muy mal</h2>
            <p style={{ marginTop: '0.5rem', fontSize: '0.875rem', color: '#6b7280' }}>Estamos trabajando en una solución.</p>
            <button
              onClick={() => reset()}
              style={{ marginTop: '1.5rem', padding: '0.625rem 1.5rem', borderRadius: '0.75rem', background: '#0072fb', color: 'white', border: 'none', cursor: 'pointer', fontWeight: '500', fontSize: '0.875rem' }}
            >
              Intentar de nuevo
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
